
<template>
<div class="item-content">
  <div class="content-upload">
    <a-upload
      :show-upload-list="false"
      :multiple="fileNumber ===1?false:true"
      :before-upload="beforeUpload"
      @change="handleFileChange"
    >

      <a-button class="uploadBtn" :disabled="uploading" type="primary">
        <img class="uploadStyle" src="@/assets/img/icon/upload.png" alt="">
        选择文件
      </a-button>
    </a-upload>
  </div>
  <p v-if="showTips" class="upload-tip">上传文件最大数量{{fileNumber}}个，支持扩展名.rar  .zip .doc .docx .pdf .jpg .png .xls .xlsx常见文件格式</p>
  <div v-if="fileData.length > 0" class="fileTips">
    <p v-for="(item, index) in fileData" :key="item.fileUrl" class="filename" @mouseenter="mouseenter(index)" @mouseleave="mouseleave">
      <img class="filenameLeft" src="@/assets/img/icon/icon_file1.png" alt="">
      <span class="fileNameStyle">{{item.fileName}}</span>
      <img class="filenameRight" :src="moveindex === index ? rightImg[1] : rightImg[0]" alt="" @click="removeFile(index)">
    </p>
  </div>
</div>
</template>

<script>
import { getFileNameSuffix } from "@/utils/handleFile.js";
import righta from "@/assets/img/icon/icon_lajitong2.png";
import rightb from "@/assets/img/icon/icon_lajitong1.png";
import { multipleFiles } from '../../api.js'

export default {
  components: {
  },
  model: {
    prop: 'fileList',
    event: 'change'
  },
  props: {
    fileList: {
      required: true
    },
    showTips:{
      type:Boolean,
      default: true
    },
    maxSize:{ // 以兆数为单位
      type:Number,
      default: 10
    },
    fileNumber:{
      type:Number,
      default: 20
    }
  },
  data () {
    return {
      // 文件最大10M
      fileMaxSize: 1024 * 1024 * this.maxSize,
      // 文件类型暂时只支持
      fileTypeLimit: [".xlsx", ".rar", ".zip", ".doc", ".docx", ".pdf", ".jpg", ".png", ".xls"],
      // 上传进度
      uploadProgress: 0,
      uploading: false,
      fileData: [],
      rightImg: [righta, rightb],
      moveindex: -1
    }
  },
  computed: {
  },
  watch:{
  },
  methods: {
    removeFile(index){
      this.fileData.splice(index, 1)
      this.$emit('change', this.fileData)
    },
    handleFileChange() {
      this.$emit('change', this.fileData)
    },
    beforeUpload(file) {
      this.validateFile(file);
      return false;
    },
    validateFile(file) {
      const { fileMaxSize, fileTypeLimit } = this;
      const fileSize = file.size;
      const fileType = getFileNameSuffix(file.name);

      if (!fileTypeLimit.includes(fileType)) {
        this.$message.error(`文件格式仅支持${this.fileTypeLimit.join(',')}类型`);
        return;
      }
      if (fileSize > fileMaxSize) {
        this.$message.error("文件最大不超过10M");
        return;
      }
      if(this.fileData.length >= this.fileNumber){
        this.$message.error(`最多支持${this.fileNumber}个文件`);
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      multipleFiles(formData).then((res) => {
        if(res && res.length > 0){
          this.fileData.push(res[0])
        }
      })
    },
    mouseenter(index){
      this.moveindex = index
    },
    mouseleave(){
      this.moveindex = -1
    },
    setFileData(data){
      this.$set(this,'fileData',data)
    }
  },
}
</script>

<style lang="less" scoped>
.uploadStyle{
  margin-right: 12px;
  vertical-align: bottom;
}
.uploadBtn{
  padding: 6px 36px;
}
.upload-tip {
  margin-top: 16px;
  margin-bottom: 24px;
  color: #A9ABAE;
  font-size: 12px;
}
.upload-progress {
  margin-top: 25px;
}
.filename {
  width: 536px;
  height: 32px;
  font-size: 14px;
  color: #171717;
  line-height: 32px;
  margin-bottom: 8px;
  .filenameLeft{
    margin-right: 8px;
    vertical-align: middle;
  }
  .filenameRight{
    float: right;
    margin-top: 8px;
    &:hover{
      cursor: pointer;
    }
  }
  .fileNameStyle{
    display: inline-block;
    vertical-align: middle;
    width: 70%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
}
.item-content{
  padding-left: 32px;
}
.fileTips{
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #EBEDF0;
  padding: 16px;
}
</style>
